// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__2ZK5M","validationTips":"StatementDescriptor_validationTips__2BYCP"};